export const toggleModalGeneric = (name) => ({ type: "TOGGLE_MODAL_GENERIC", name });
